import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';

@Component({
  selector: 'sd-pickup-info',
  templateUrl: './pickup-info.component.html',
  styleUrls: ['./pickup-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupInfoComponent {
  iconType = CUSTOM_ICON_TYPE;

  @HostBinding('class') @Input() type: 'error' | 'warning' | 'success' = 'error';
}
